import { render, staticRenderFns } from "./ExpandableContainer.vue?vue&type=template&id=2c26adb9&"
import script from "./ExpandableContainer.vue?vue&type=script&lang=ts&"
export * from "./ExpandableContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports